import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSessionUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getSessionIdFromUrl = useCallback(() => searchParams.get('sessionId'), [searchParams]);

  const setSessionIdInUrl = useCallback(
    (sessionId: string) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('sessionId', sessionId);
      setSearchParams(newSearchParams);
    },
    [searchParams, setSearchParams],
  );

  const sessionId = getSessionIdFromUrl();

  return { setSessionIdInUrl, sessionId };
};
